"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _localization = require("@lt/localization");

var _MobileRoomGallery = _interopRequireDefault(require("../MobileRoomGallery"));

var _Tab = _interopRequireDefault(require("../Tab"));

var _Tabs = _interopRequireDefault(require("../Tabs"));

var _LabelList = require("../Label/LabelList");

var _HotelOffersTableMobile = _interopRequireDefault(require("../HotelOffersTableMobile"));

var _HotelRoomFacilities = _interopRequireDefault(require("../HotelRoomDescription/HotelRoomFacilities"));

var _HotelRoomOffersSkeleton = _interopRequireDefault(require("../HotelRoomOffersSkeleton/HotelRoomOffersSkeleton"));

var _hotel = require("../../proptypes/hotel");

var _HotelRoomName = _interopRequireWildcard(require("../HotelRoomDescription/HotelRoomName"));

var _CashBack = _interopRequireDefault(require("../CashBack"));

var _excluded = ["room", "nights", "offers", "selectedNights", "mealTypes", "hotelFacilities", "onOfferClicked", "labels", "bonusCount", "cashbackIdentifier", "customCashbackIconURL", "customCashbackText", "customCashbackTooltipText", "isHotelOnly", "isWhiteLabel", "onClickGallery"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var YELLOW_TRIANGLE_HEIGHT = 8;
var YELLOW_TRIANGLE_OFFSET = 3;
var TABS = {
  price: {
    id: 'price',
    label: _localization.i18n.t('hotel.room.price'),
    // unfortunally we can't make flexible shapes
    width: 55
  },
  facilities: {
    id: 'facilities',
    label: _localization.i18n.t('hotel.room.facilities_mobile'),
    width: 135
  }
}; // ms to set slide visually active.

var SLIDE_CHANGE_DELAY = 100;

var HotelRoomOfferMobile = function HotelRoomOfferMobile(props) {
  var room = props.room,
      nights = props.nights,
      offers = props.offers,
      selectedNights = props.selectedNights,
      mealTypes = props.mealTypes,
      hotelFacilities = props.hotelFacilities,
      onOfferClicked = props.onOfferClicked,
      labels = props.labels,
      bonusCount = props.bonusCount,
      cashbackIdentifier = props.cashbackIdentifier,
      customCashbackIconURL = props.customCashbackIconURL,
      customCashbackText = props.customCashbackText,
      customCashbackTooltipText = props.customCashbackTooltipText,
      isHotelOnly = props.isHotelOnly,
      isWhiteLabel = props.isWhiteLabel,
      onClickGallery = props.onClickGallery,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var roomName = room.name_ru,
      roomNameEn = room.name_en,
      area = room.area,
      facilities = room.facilities,
      description = room.description,
      images = room.images,
      idRoom = room.id;

  var _useState = (0, _react.useState)(nights.indexOf(selectedNights)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeSlide = _useState2[0],
      setActiveSlide = _useState2[1];

  var _useState3 = (0, _react.useState)(TABS.price.id),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      selectedTab = _useState4[0],
      setSelectedTab = _useState4[1];

  var roomImages = (0, _react.useMemo)(function () {
    return images ? images.map(function (image) {
      return image.x900;
    }) : [];
  }, [images]);
  var onSlideChange = (0, _react.useMemo)(function () {
    return function (slide) {
      return setTimeout(setActiveSlide(slide), SLIDE_CHANGE_DELAY);
    };
  }, []);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      rendered = _useState6[0],
      setRendered = _useState6[1];

  (0, _react.useEffect)(function () {
    var timeout;

    if (!rendered) {
      timeout = setTimeout(function () {
        return setRendered(true);
      }, 0);
    }

    return function () {
      clearTimeout(timeout);
    };
  });

  if (!rendered) {
    return /*#__PURE__*/_react["default"].createElement(_HotelRoomOffersSkeleton["default"], (0, _extends2["default"])({}, rest, {
      isMobile: true
    }));
  }

  var existRoomImages = !(0, _isEmpty2["default"])(roomImages);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelRoomOfferMobile, rest, bonusCount ? /*#__PURE__*/_react["default"].createElement(StyledCashBack, {
    count: "+".concat(bonusCount),
    type: cashbackIdentifier,
    customCashbackIconURL: customCashbackIconURL,
    customCashbackText: customCashbackText,
    customCashbackTooltipText: customCashbackTooltipText,
    isMobile: true,
    cashbackText: true,
    existRoomImages: existRoomImages
  }) : null, existRoomImages ? /*#__PURE__*/_react["default"].createElement(StyledGallery, {
    onClickGallery: onClickGallery,
    images: roomImages,
    id: idRoom
  }) : null, /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledRoomName, {
    name: roomName,
    originalName: roomNameEn,
    area: area
  }), /*#__PURE__*/_react["default"].createElement(StyldLabelList, {
    labels: labels,
    maxLabels: 6
  }), /*#__PURE__*/_react["default"].createElement(StyledTabs, {
    onChange: setSelectedTab
  }, Object.values(TABS).map(function (_ref) {
    var id = _ref.id,
        label = _ref.label,
        width = _ref.width;
    return /*#__PURE__*/_react["default"].createElement(StyledTab, {
      key: id,
      value: id,
      selected: selectedTab === id,
      width: width
    }, label, selectedTab === id && /*#__PURE__*/_react["default"].createElement(StyledYellowTriangle, {
      width: width
    }));
  }))), /*#__PURE__*/_react["default"].createElement(StyledTabContent, {
    isVisible: selectedTab === TABS.price.id
  }, /*#__PURE__*/_react["default"].createElement(_HotelOffersTableMobile["default"], {
    offers: offers,
    nights: nights,
    mealTypes: mealTypes,
    onOfferClicked: onOfferClicked,
    onSlideChange: onSlideChange,
    activeSlide: activeSlide,
    selectedNights: selectedNights,
    isHotelOnly: isHotelOnly,
    isWhiteLabel: isWhiteLabel
  })), /*#__PURE__*/_react["default"].createElement(StyledTabContent, {
    isVisible: selectedTab === TABS.facilities.id
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelRoomFacilities, {
    facilities: facilities,
    description: description,
    hotelFacilities: hotelFacilities,
    isMobile: true
  })));
};

HotelRoomOfferMobile.propTypes = {
  className: _propTypes["default"].string,
  onOfferClicked: _propTypes["default"].func.isRequired,
  room: _hotel.RoomPropTypes.isRequired,
  mealTypes: _propTypes["default"].arrayOf(_hotel.MealTypePropTypes).isRequired,
  offers: _propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired,
  nights: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  selectedNights: _propTypes["default"].number.isRequired,
  hotelFacilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  bonusCount: _propTypes["default"].number,
  isWhiteLabel: _propTypes["default"].bool
};
HotelRoomOfferMobile.defaultProps = {
  className: '',
  hotelFacilities: null,
  labels: []
};
var StyledCashBack = (0, _styledComponents["default"])(_CashBack["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledCashBack",
  componentId: "sc-1mh2rvq-0"
})(["", ";"], function (_ref2) {
  var existRoomImages = _ref2.existRoomImages;
  return existRoomImages && (0, _styledComponents.css)(["position:absolute;z-index:2;left:9px;top:9px;"]);
});
var StyldLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelRoomOffersMobile__StyldLabelList",
  componentId: "sc-1mh2rvq-1"
})(["margin-top:8px;"]);
var StyledTab = (0, _styledComponents["default"])(_Tab["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledTab",
  componentId: "sc-1mh2rvq-2"
})(["font-size:13px;font-weight:", ";color:", ";height:35px;width:", ";position:relative;", ";button{position:relative;z-index:1;padding-bottom:10px;}"], function (props) {
  return props.selected ? 'bold' : 'normal';
}, function (props) {
  return props.selected ? props.theme.colors.blackBase : props.theme.colors.blackLight;
}, function (_ref3) {
  var width = _ref3.width;
  return "".concat(width, "px");
}, function (_ref4) {
  var theme = _ref4.theme,
      selected = _ref4.selected;
  return selected && (0, _styledComponents.css)(["::before{content:'';position:absolute;background-color:", ";left:0;bottom:", "px;top:0;right:0;z-index:1;border-radius:", ";}"], theme.colors.yellowBase, YELLOW_TRIANGLE_HEIGHT, theme.shape.borderRadius);
});

var StyledYellowTriangle = _styledComponents["default"].i.withConfig({
  displayName: "HotelRoomOffersMobile__StyledYellowTriangle",
  componentId: "sc-1mh2rvq-3"
})(["position:absolute;width:0;height:0;z-index:1;left:", "px;bottom:0;border-top:", "px solid ", ";border-left:", ";border-right:", ";"], YELLOW_TRIANGLE_OFFSET, YELLOW_TRIANGLE_HEIGHT, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.yellowBase;
}, function (_ref6) {
  var width = _ref6.width,
      theme = _ref6.theme;
  return "".concat(width / 2 - YELLOW_TRIANGLE_OFFSET, "px solid ").concat(theme.colors.white);
}, function (_ref7) {
  var width = _ref7.width,
      theme = _ref7.theme;
  return "".concat(width / 2 - YELLOW_TRIANGLE_OFFSET, "px solid ").concat(theme.colors.white);
});

var StyledTabs = (0, _styledComponents["default"])(_Tabs["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelRoomOffersMobile__StyledTabs",
  componentId: "sc-1mh2rvq-4"
})(["display:flex;margin:10px 0;"]);

var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersMobile__StyledWrapper",
  componentId: "sc-1mh2rvq-5"
})(["margin-top:6px;margin-left:10px;"]);

var StyledHotelRoomOfferMobile = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersMobile__StyledHotelRoomOfferMobile",
  componentId: "sc-1mh2rvq-6"
})(["padding-left:5px;padding-top:5px;border-radius:4px;background:white;position:relative;"]);

var StyledHotelRoomFacilities = (0, _styledComponents["default"])(_HotelRoomFacilities["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledHotelRoomFacilities",
  componentId: "sc-1mh2rvq-7"
})(["margin:10px;"]);
var StyledGallery = (0, _styledComponents["default"])(_MobileRoomGallery["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledGallery",
  componentId: "sc-1mh2rvq-8"
})(["border-top-left-radius:4px;border-bottom-left-radius:4px;overflow:hidden;"]);
var StyledRoomName = (0, _styledComponents["default"])(_HotelRoomName["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledRoomName",
  componentId: "sc-1mh2rvq-9"
})(["", "{font-size:11px;}"], _HotelRoomName.StyledSubtext);

var StyledTabContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersMobile__StyledTabContent",
  componentId: "sc-1mh2rvq-10"
})(["display:", ";"], function (_ref8) {
  var isVisible = _ref8.isVisible;
  return isVisible ? 'block' : 'none';
});

var _default = /*#__PURE__*/_react["default"].memo(HotelRoomOfferMobile);

exports["default"] = _default;